export default "__VITE_ASSET__D1T908Qv__"